import { defineMessages, useIntl } from 'react-intl';

import CalmGradientText from '../CalmGradientText';
import { Body, Splash } from './styles';

const messages = defineMessages({
	header: {
		id: 'book.benefits.header',
		defaultMessage: 'Calm the mind. Change the world',
		description: 'Header Text for a marketing page for a book',
	},
	bodyContainer: {
		id: 'book.benefits.bodyContainer',
		defaultMessage:
			'Modern life is hectic and relentless: trains delayed, endless emails filling the inbox, kids squabbling before bedtime… There has never been a more important time to rediscover your pause button. Calm is the book that will show you how to take back a little bit of peace, space and all-important calm. This book contains the simple tools, tricks and habits that will change the rest of your life. It is a practical and pleasurable guide to twenty-first century mindfulness.',
		description: 'Marketing copy for selling a book',
	},
});

const Benefits = () => {
	const { formatMessage } = useIntl();

	return (
		<div>
			<CalmGradientText text={formatMessage(messages.header)} />
			<div>
				<Body>{formatMessage(messages.bodyContainer)}</Body>
			</div>
			<Splash role="presentation" />
		</div>
	);
};

export default Benefits;
